<div class="header">
    <div class="box">?</div>
    <h1>{{'achievement.leaderboard_pop_up_header' | translate}}</h1>
</div>
<div class="body">{{'achievement.leaderboard_pop_up_body' | translate}}</div>
<button *ngIf="data?.isInSnackbar" (click)="onClick()">{{'snackbar.ok' | translate}}</button>
